import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';

type SearchParams = Record<string, string | undefined>;

function isUnreadFilterActive() {
  return m.route.param('unread') === '1';
}

function unreadButtonConfig() {
  if (isUnreadFilterActive()) {
    return {
      icon: 'fas fa-check',
      label: app.translator.trans('erp-russia-unread-feed.forum.view.unread_filter'),
    };
  }

  return {
    icon: 'fas fa-list',
    label: app.translator.trans('erp-russia-unread-feed.forum.view.all_filter'),
  };
}

function currentRouteParams(): SearchParams {
  return { ...(m.route.param() as SearchParams) };
}

function toggleUnreadRoute() {
  const params = currentRouteParams();

  delete params.page;

  if (isUnreadFilterActive()) {
    delete params.unread;
  } else {
    params.unread = '1';
  }

  setRouteWithForcedRefresh(app.route(app.current.get('routeName'), params));
}

export default function addUnreadToolbarToggle() {
  extend(IndexPage.prototype, 'viewItems', function (items) {
    if (!app.session.user) {
      return;
    }

    const button = unreadButtonConfig();

    items.add(
      'unreadToggle',
      <Button className="Button UnreadFilterButton" icon={button.icon} active={isUnreadFilterActive()} onclick={toggleUnreadRoute}>
        {button.label}
      </Button>,
      90
    );
  });

  extend(GlobalSearchState.prototype, 'stickyParams', function (params: SearchParams) {
    if (isUnreadFilterActive()) {
      params.unread = '1';
    }
  });

  extend(GlobalSearchState.prototype, 'params', function (params: SearchParams & { onUnread?: boolean }) {
    params.onUnread = isUnreadFilterActive();
  });

  extend(DiscussionListState.prototype, 'requestParams', function (params: { filter?: Record<string, string> }) {
    if (!this.params.onUnread) {
      return;
    }

    params.filter ||= {};

    if (params.filter.q) {
      params.filter.q += ' is:unread';
    } else {
      params.filter.unread = '1';
    }
  });
}
